import type { AuthoredArticle } from './types'
import { articles01 } from './articles-01.ts'
import { articles02 } from './articles-02.ts'
import { articles03 } from './articles-03.ts'
import { articles04 } from './articles-04.ts'
import { articles05 } from './articles-05.ts'
import { articles06 } from './articles-06.ts'
import { articles07 } from './articles-07.ts'
import { articles08 } from './articles-08.ts'
import { articles09 } from './articles-09.ts'
import { articles10 } from './articles-10.ts'

// All hand-written articles, merged into the seed catalog by blog.ts.
export const authoredArticles: AuthoredArticle[] = [
  ...articles01,
  ...articles02,
  ...articles03,
  ...articles04,
  ...articles05,
  ...articles06,
  ...articles07,
  ...articles08,
  ...articles09,
  ...articles10,
]

export type { AuthoredArticle } from './types'
